import React from 'react';

import styled from 'styled-components';

const ChipLabel = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
`;

const LaggingChipText = styled.span`
  font-size: 10px;
  color: var(--text-secondary);

  button.ant-btn-primary &,
  button:hover & {
    color: inherit;
  }
`;

type Props = {
  label: string;
  laggingCount: number;
};

const CompanyAiCompetitiveIntelligenceLaggingChipLabel = ({ label, laggingCount }: Props) => (
  <ChipLabel>
    <span>{label}</span>
    <LaggingChipText>{laggingCount} lagging</LaggingChipText>
  </ChipLabel>
);

export default CompanyAiCompetitiveIntelligenceLaggingChipLabel;
